import type { PLCPaginationDTO } from '@/models/dto/plc/plc-pagination-dto'
import type { PLCsWithPagination } from '@/models/types/plc/plcs-with-pagination'
import { mapToPagination, mapToPaginationDTO } from '../pagination-mapper'
import { mapToPLC, mapToPlcDTO } from './plc-mapper'

const mapToPLCsDTO = (plcs: PLCsWithPagination): PLCPaginationDTO => {
    return {
        plc: plcs.plcs?.map(mapToPlcDTO) ?? null,
        paginationData: plcs.pagination ? mapToPaginationDTO(plcs.pagination) : null,
    }
}

const mapToPLCs = (dto: PLCPaginationDTO): PLCsWithPagination => {
    return {
        plcs: dto.plc?.map((plc) => mapToPLC(plc)),
        pagination: dto.paginationData ? mapToPagination(dto.paginationData) : undefined,
    }
}

export { mapToPLCs, mapToPLCsDTO }
